var app = angular.module('leonardo');

var PriorityFilter = function (TemplateService) {
  return function (option) {
    if ((option !== null) && (option !== undefined) && (option !== ''))
      switch (option.toString()) {
        case TemplateService.PRIORITY_MINOR:
          return 'Minor';
        case TemplateService.PRIORITY_NORMAL:
          return 'Normal';
        case TemplateService.PRIORITY_CRITICAL:
          return 'Critical';
      }
    return 'Invalid priority';
  }
};

app.filter('priority', ['TemplateService', PriorityFilter]);
